import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  FormHelperText,
  MenuItem,
  Radio,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CustomRadioGroup from "@components/CustomRadioGroup";
import { useState } from "react";
import CustomCircularProgress from "@components/CustomCircularProgress";

export const Components = () => {
  const [checkboxValue, setCheckboxValue] = useState<string>("");
  const [radioValue, setRadioValue] = useState<string>("");
  const [textFieldValue, setTextFieldValue] = useState<string>("");
  const [selectValue, setSelectValue] = useState<string>("");
  const [errorTextField, setErrorTextField] = useState<boolean>(false);
  const [helperTextField, setHelperTextField] = useState<string>("");

  return (
    <Container>
      <Box>
        <Typography variant="h1">Textos</Typography>
        <Typography variant="h1">Texto H1</Typography>
        <Typography variant="h2">Texto H2</Typography>
        <Typography variant="h3">Texto H3</Typography>
        <Typography variant="h4">Texto H4</Typography>
        <Typography variant="h5">Texto H5</Typography>
        <Typography variant="body1">Texto Body 1</Typography>
        <Typography variant="body2">Texto Body 2</Typography>
        <Typography variant="body3">Texto Body 3</Typography>
      </Box>

      <Box>
        <Typography variant="h1">Botones</Typography>
        <Button variant="contained">Texto Button</Button>
        <Button variant="outlined">Texto Button</Button>
      </Box>

      <Box>
        <Typography variant="h1">Checkbox</Typography>
        <Checkbox
          id="checkbox"
          name="uses"
          value="checkbox"
          checked={checkboxValue === "checkbox"}
          onChange={(event) => {
            const { value, checked } = event.target;
            if (checked) {
              setCheckboxValue(value);
            } else {
              setCheckboxValue("");
            }
          }}
        />

        <Checkbox id="checkbox2" name="uses" value="checkbox2" checked={checkboxValue === "checkbox"} disabled={true} />
      </Box>

      <Box mt={2}>
        <Typography variant="h1">Radio</Typography>
        <Radio
          id="radio"
          name="uses"
          value="radio"
          checked={radioValue === "radio"}
          onChange={(event) => setRadioValue(event.target.value)}
        />
      </Box>

      <Box mt={2}>
        <Typography variant="h1">Radio group</Typography>
        <CustomRadioGroup
          label={"¿Realizarás pagos anticipados?"}
          name={"advancePayments"}
          value={radioValue}
          onChange={(event) => setRadioValue(event.target.value)}
          options={[
            {
              label: "Si",
              value: "Si",
            },
            {
              label: "No",
              value: "No",
            },
          ]}
        />
      </Box>

      <Box mt={2}>
        <Typography variant="h1">TextField</Typography>

        <FormControl>
          <TextField
            id="textfield"
            name="textfield"
            value={textFieldValue}
            onChange={(event) => setTextFieldValue(event.target.value)}
            error={errorTextField}
            helperText={helperTextField}
            required
          />
        </FormControl>
      </Box>

      <Box mt={2}>
        <Typography variant="h1">Form Helper Text</Typography>
        <FormHelperText>Helper Text Normal</FormHelperText>
        <FormHelperText error={true}>Helper Text Error</FormHelperText>
      </Box>

      <Box mt={2}>
        <Typography variant="h1">Select</Typography>
        <Select id="select" name="select" value={selectValue} onChange={(event) => setSelectValue(event.target.value)}>
          <MenuItem value="1">Option 1</MenuItem>
          <MenuItem value="2">Option 2</MenuItem>
          <MenuItem value="3">Option 3</MenuItem>
        </Select>
        <Select
          id="select2"
          name="select2"
          value={selectValue}
          onChange={(event) => setSelectValue(event.target.value)}
        >
          <MenuItem value="1">Option 1</MenuItem>
          <MenuItem value="2">Option 2</MenuItem>
          <MenuItem value="3">Option 3</MenuItem>
        </Select>
      </Box>

      <Box mt={2}>
        <Typography variant="h1">Circular Progress</Typography>
        {/* <CircularProgress color="primary" /> */}
        <CustomCircularProgress size={150} />
      </Box>
    </Container>
  );
};
